export const getCurrencyMockNameByTag = (tag) => {
  return `${tag.country} CBDC`
}
